<template>
  <div class="all-course fadeIn">
    <div class="title-box">
      <div class="main-title">浙江大学出版社</div>
      <a-input-search class="input-search" v-model:value="keyword" placeholder="请输入教材名称搜索" @search="onSearch" />
    </div>
    <div class="course">
      <div class="catalog-box" v-if="catalogList.length > 0">
        <div class="catalog">
          <div class="catalog-item" :class="{ selected: catActive == i, noicon: !catalog.icon }"
            v-for="(catalog, i) of catalogList" @click="chooseCatalog(i)">
            <i class="catalog-icon" :style="{ backgroundImage: 'url(' + catalog.icon + ')' }" v-if="catalog.icon"></i>
            <span class="catalog-title">{{ catalog.name }}</span>
          </div>
        </div>
      </div>
      <div class="title-text">{{ catalogList[catActive]?.name }}</div>

      <div class="course-box">
        <div class="course-item-box" :class="{ hide: i > 9 }" v-for="(course, i) of storeBooks"
          @click="routerCourse(course)">
          <div class="course-item" :style="{ backgroundImage: 'url(' + course.extension_info?.cover + ')' }">
            <div class="course-top" @click.stop>
              <a-tooltip title="详情">
                <div class="svg-box info" @click="routerPath(`/course-info/${course.pk_store_book_id}`)">
                  <svg class="icon-svg">
                    <use xlink:href="#icon-info"></use>
                  </svg>
                </div>
              </a-tooltip>
            </div>
          </div>
          <div class="course-name">{{ course.name }}</div>
        </div>
        <emptyBox warning="Sorry,暂无此类教材" v-if="storeBooks.length == 0"></emptyBox>
      </div>

    </div>
    <foot></foot>
  </div>
</template>

<script>
// @ is an alias to /src
import foot from "@/component/public/foot/foot.vue";
import router from '@/router';
import emptyBox from "@/component/public/empty-box/empty-box.vue";

export default {
  name: 'home',
  components: {
    foot,
    emptyBox
  },
  data() {
    return {
      catalogList: [],
      allDigitalBookList: [],
      storeBooks: [],

      catActive: 0,
      keyword: '',

      loadding: true,
      phoneMode: true,

      vipPastdue: true,
    }
  },
  mounted() {
    this.$store.commit('showReturn', true);
    $('#content').animate({ scrollTop: 0 }, 300);
    let { keyword } = this.$route.query;
    if (keyword) this.keyword = keyword;

    this.setPageTemplate();
  },
  methods: {
    //设置pageTemplate
    setPageTemplate() {
      const { userInfo, storeBooks, phoneMode, vipInfo } = this.$store.state;
      this.user = userInfo;
      this.allDigitalBookList = storeBooks;
      this.phoneMode = phoneMode;
      if (vipInfo) this.vipPastdue = vipInfo.isPastdue;

      let catActive = 0;

      this.chooseCatalog(catActive);
    },
    //选择分类
    chooseCatalog(i) {
      this.catActive = i;
      this.onSearch();
    },
    //关键词搜索
    onSearch() {
      let catalog = this.catalogList[this.catActive];
      let allDigitalBookList = this.allDigitalBookList;

      let storeBooks = allDigitalBookList.filter(item => item.type_list.indexOf(catalog?.id) > -1);
      if (!catalog || !catalog.id) storeBooks = allDigitalBookList;

      this.storeBooks = storeBooks.filter((item) => item.name.indexOf(this.keyword) > -1);

      this.loadding = false;
    },
    //跳转
    chooseCourse(item) {
      $('#content').css('overflow-y', 'auto')
      $('#content').css('padding-right', '0px')
      router.push(`/course-info/${item.pk_store_book_id}`);
    },
    //跳转
    routerPath(url) {
      this.$router.push(url);
    },
    //跳转
    routerCourse(item) {
      if (item.isPaid || !this.vipPastdue) {
        this.study(item);
      }
      else {
        $("#content").css("overflow-y", "auto");
        $("#content").css("padding-right", "0px");
        router.push(`/course-info/${item.pk_store_book_id}`);
      }
    },
    //学习
    study(item) {
      const { pk_store_book_id, single_url } = item;
      const url = single_url || `/bookReader/${pk_store_book_id}`;
      window.open(url);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./all-course.scss";
</style>
